(function () {

    'use strict';

    // NOTE ensure the namespace and any dependencies are set up appropriately, for both server and client
    if (typeof window === 'undefined') {

        module.exports = definition();

    } else {

        RivalIQ.module('enums');
        RivalIQ.enums.insightsObjectType = definition();

    }

    function definition() {

        return {
            story: 'story',
            storyDay: 'storyDay',
            post: 'post',
            reel: 'reel'
        };
    }
})();
